// Einmal-Login-Link bestaetigen. GET-Link zeigt nur diese Seite (Link-Scanner-sicher);
// die Sitzung entsteht erst beim Klick per POST /api/auth/magic/confirm.
import React, { useState } from "react";
import { useSearchParams } from "react-router-dom";
import { ArrowRight, Loader2 } from "lucide-react";
import { api } from "@/lib/api";
import { getGaContext } from "@/lib/ga4";

const ERRORS = {
  token_used: "Dieser Link wurde bereits verwendet. Fordere bitte einen neuen Login-Link an.",
  token_expired: "Dieser Link ist abgelaufen. Fordere bitte einen neuen Login-Link an.",
};

export default function MagicConfirm() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState(token ? "" : "Dieser Link ist ungültig.");

  async function confirm() {
    setBusy(true);
    setError("");
    try {
      const ga4 = await getGaContext().catch(() => ({}));
      const { data } = await api.post("/auth/magic/confirm", { token, ga4 });
      window.location.replace(data?.redirect_to || "/dashboard");
    } catch (err) {
      const code = err?.response?.data?.detail;
      setError(ERRORS[code] || "Dieser Link ist ungültig.");
      setBusy(false);
    }
  }

  return (
    <div className="min-h-[70vh] bg-[#FAF7F2] flex items-center justify-center px-5" data-testid="magic-confirm-page">
      <div className="w-full max-w-md text-center">
        <h1 className="text-3xl font-extrabold text-slate-900" data-testid="magic-confirm-headline">Fast geschafft.</h1>
        <p className="mt-3 text-base text-slate-600">Ein Klick, und dein PocketCoach öffnet sich.</p>
        {error && <div className="mt-6 rounded-xl border border-rose-200 bg-rose-50 px-4 py-3 text-sm text-rose-700" data-testid="magic-confirm-error">{error}</div>}
        {token && !error.includes("bereits") && (
          <button type="button" onClick={confirm} disabled={busy} data-testid="magic-confirm-button"
            className="group mt-8 inline-flex w-full items-center justify-center gap-2 rounded-full bg-[var(--fts-accent)] px-6 py-4 text-lg font-bold text-white shadow-lg transition-opacity hover:opacity-95 disabled:opacity-60">
            {busy ? <><Loader2 className="h-5 w-5 animate-spin" /> Einen Moment …</> : <>PocketCoach öffnen <ArrowRight className="h-5 w-5 transition-transform group-hover:translate-x-1" /></>}
          </button>
        )}
      </div>
    </div>
  );
}
